// TODO: account for p2.computed relying on p1.computed; use getters???
import {UPDATE_AFFECTED_COMPONENTS, PROPS} from '../symbols';
import filterComputedProperties from './filterComputedProperties';
import computeProperty from './computeProperty';
import quickEquals from './helpers/quickEquals';

export default function resolveComputedProperties(state, host, hostVariables, interactionId) {
	const computed = filterComputedProperties(host);
	state.properties = state.properties || {};

	for (const k in computed) {
		const previousValue = hostVariables[PROPS][k];

		state.properties[k] = computeProperty(k, computed[k], {state, host});
		hostVariables[PROPS][k] = state.properties[k]; // eslint-disable-line no-param-reassign

		if (!quickEquals(state.properties[k], previousValue)) {
			host[UPDATE_AFFECTED_COMPONENTS]({
				name: k,
				propertyDetails: {
					previousValue,
					value: state.properties[k]
				},
				interactionId,
				includeSource: false
			});
		}
	}

	return state;
}
